const realAnimationFrame = global.requestAnimationFrame;
const realTimeout = global.setTimeout;

export const nextAnimationFrame = (): Promise<void> => {
	return new Promise((resolve) => {
		realAnimationFrame(() => realAnimationFrame(() => realTimeout(() => resolve(), 0)));
	});
};
